import { render, staticRenderFns } from "./newObserver.vue?vue&type=template&id=88d83d1c&scoped=true&"
import script from "./newObserver.vue?vue&type=script&lang=js&"
export * from "./newObserver.vue?vue&type=script&lang=js&"
import style0 from "./newObserver.vue?vue&type=style&index=0&id=88d83d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d83d1c",
  null
  
)

export default component.exports